<template>
  <div class="popup__wrapper popup__wrapper_socCards">
    <img
        class="popup__icon"
        @mouseover="showPopup = true" @mouseleave="hideContent()"
        src="@/create/assets/icons/msg-question.svg" alt="?"
    >
    <div v-show="showPopup" class="popup__content popup__content--makc-social-card">
      <img class="popup__content--makc-social-card-img" src="@/create/assets/images/social_cart_msc.png"
           alt="образец социальной карты" v-if="type === 'msc'">
      <img class="popup__content--makc-social-card-img" src="@/create/assets/images/social_cart_spb.png"
           alt="образец социальной карты" v-if="type === 'spb'">
    </div>
  </div>
</template>

<script>
export default {
  props: ['type'],
  data() {
    return {
      showPopup: false,
    };
  },
  computed: {
    isMobile() { // f5 для применения изменений
      return window.innerWidth <= 768;
    }
  },
  methods: {
    hideContent() {
      setTimeout(() => {
        this.showPopup = false
      }, 0);
    },
  },
}
</script>
<style lang="scss">
@import "@/create/assets/scss/style.scss";
</style>
